<template>
	<div id="wrapper">
		<div id="bg" :style="{ backgroundImage: 'url('+config.full_login_bgimg+')' }"></div>
		<div id="overlay"></div>
		<div id="main">
			<header id="header" style="z-index: 999">
				<h1 style="color:#fff">{{config.login_title}}</h1>
				<p>{{config.login_entitle}}</p>
				<div class="content">
					<div class="right">
						<div class="gotoMinPro">
							<div class="pFif">
								<div class="title">扫码学习</div>
								<div class="imgBg">
									<img src="../../assets/index/quickMarkBg.png" alt="扫码学习" />
								</div>
							</div>
							<div class="quickMark">
								<img :src="$https+config.login_qrcode" alt="扫码学习" />
							</div>
						</div>
						<div class="topic">
							<div class="name">欢迎登陆</div>
						</div>
						<div style="padding: 20px;margin-top: 10px;">
							<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px"
								class="demo-ruleForm">
								<el-form-item prop="account">
									<el-input v-model="ruleForm.account" prefix-icon="el-icon-s-custom"
										placeholder="请输入您的身份证/手机号"></el-input>
								</el-form-item>
								<el-form-item prop="password">
									<el-input v-model="ruleForm.password" prefix-icon="el-icon-lock" placeholder="请输入密码"
										show-password></el-input>
								</el-form-item>
								<div class="check">
									<div>
										<el-checkbox v-model="checked">登录即同意</el-checkbox>
										<a @click="handleOpen">《用户协议》</a>
									</div>
									<div @click="forgotpwd">忘记密码？</div>
								</div>
								<el-form-item>
									<el-button class="but" type="primary" @click="submitForm('ruleForm')">立即登录
									</el-button>
								</el-form-item>
							</el-form>
							<div class="rest" @click="register">还没有账号？立即注册</div>
						</div>

					</div>
				</div>
				<nav>
					<ul>
						<li class="first">
							<img src="../../assets/index/learn.png" alt="" />
						</li>
						<li class="itemLink">
							<div class="icon">
								<img src="../../assets/index/icon1.png" alt="" />
							</div>
							<div class="topicIn">注册登录</div>
						</li>
						<li class="itemTo">
							<img src="../../assets/index/iconLink.png" alt="" x />
						</li>
						<li class="itemLink">
							<div class="icon">
								<img src="../../assets/index/icon2.png" alt="" />
							</div>
							<div class="topicIn">选课缴费</div>
						</li>
						<li class="itemTo">
							<img src="../../assets/index/iconLink.png" alt="" />
						</li>
						<li class="itemLink">
							<div class="icon">
								<img src="../../assets/index/icon3.png" alt="" />
							</div>
							<div class="topicIn">开始学习</div>
						</li>
						<li class="itemTo">
							<img src="../../assets/index/iconLink.png" alt="" />
						</li>
						<li class="itemLink">
							<div class="icon">
								<img src="../../assets/index/icon4.png" alt="" />
							</div>
							<div class="topicIn">开始考试</div>
						</li>
						<li class="itemTo">
							<img src="../../assets/index/iconLink.png" alt="" />
						</li>
						<li class="itemLink">
							<div class="icon">
								<img src="../../assets/index/icon5.png" alt="" />
							</div>
							<div class="topicIn">生成证书</div>
						</li>
					</ul>
				</nav>
			</header>
			<footer id="footer" style="z-index:0" v-html="config.rights_reserved"></footer>
		</div>
		<!-- 用户须知 -->
		<el-dialog title="用户须知" :visible.sync="dialogVisible" width="1000px">
			<div class="modal-body" v-html="config.yhxy"></div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="Noticeble()">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 修改密码 -->
		<el-dialog title="修改密码" :visible.sync="dialogpwd" width="500px" :close-on-click-modal='false'>
			<div style="margin: 0 auto;width: 370px;">
				<el-form :model="FormRef" :rules="Refrules" ref="FormRef" label-width="80px" class="demo-ruleForm">
					<el-form-item label="类型" prop="name">
						<el-radio v-model="radio" label="email" @input="types">通过邮箱</el-radio>
						<el-radio v-model="radio" label="mobile" @input="types">通过手机重置</el-radio>
					</el-form-item>
					<el-form-item label="邮箱" prop="email" v-if="radio=='email'">
						<el-input v-model="FormRef.email" placeholder="请输入您的邮箱"></el-input>
					</el-form-item>
					<el-form-item label="手机号" prop="mobile" v-else>
						<el-input v-model="FormRef.mobile" placeholder="请输入您的手机号"></el-input>
					</el-form-item>
					<el-form-item label="验证码" prop="captcha">
						<div class="bind_code margin_top">
							<el-input class="bind_code_input code" v-model="FormRef.captcha" type="text"
								placeholder="请输入验证码" />
							<el-button @click.native.prevent="bindforgetSendCode" class="bind_code_gain"
								:disabled="disabled">{{ btnText }}</el-button>
							<img class="login-icon" src="" alt="" />
						</div>
					</el-form-item>
					<el-form-item label="新密码" prop="newpassword">
						<el-input v-model="FormRef.newpassword" placeholder="请输入您的新密码"></el-input>
					</el-form-item>
					<ul class="tips">
						<li>
							1、新密码为大小写字母和数字且至少为8位。
						</li>
						<li>
							2、新密码不应包含用户名。
						</li>
						<li>
							3、新密码不能是键盘排序。
						</li>
						<li>
							4、新密码不能包含特殊符号。
						</li>
					</ul>
					<el-form-item>
						<el-button type="primary" size="medium" @click="submitRef('FormRef')">立即修改</el-button>
						<el-button size="medium" @click="resetRef('FormRef')">重置</el-button>
					</el-form-item>
				</el-form>

			</div>
		</el-dialog>
		<!-- 修改密码 -->
		<el-dialog title="账号注册" :visible.sync="dialogrest" width="1000px" :close-on-click-modal='false' class="rests">
			<div class="froms">
				<el-form :model="ruleForms" :rules="ruless" ref="ruleForms" label-width="100px" class="demo-ruleForm">
					<!-- <div class="titles">
						基本信息
					</div> -->
					<div style="width:900px ;margin: 0 auto;">
						<el-row>
							<el-col :span="12">
								<el-form-item label="姓名" prop="nickname">
									<el-input v-model="ruleForms.nickname" placeholder="请填写姓名"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="手机号" prop="mobile">
									<el-input v-model="ruleForms.mobile" placeholder="请填写手机号"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="12">
								<el-form-item label="邮箱" prop="email">
									<el-input v-model="ruleForms.email" placeholder="请填写邮箱"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="身份证号" prop="card">
									<el-input v-model="ruleForms.card" placeholder="请填写身份证号">
									</el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="12">
								<el-form-item label="密码" prop="password">
									<el-input v-model="ruleForms.password" show-password placeholder="请填写密码(8-20个字符)">
									</el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="确认密码" prop="password_confirm">
									<el-input v-model="ruleForms.password_confirm" show-password placeholder="请填写确认密码">
									</el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-form-item label="单位名称" prop="company">
							<el-input v-model="ruleForms.company" v-if="ruleForms.group_id===2" placeholder="请填写单位名称">
							</el-input>
							<el-select v-else v-model="ruleForms.company" placeholder="请选择单位名称" style="width: 100%;">
								<el-option v-for="item in Companydata" :key="item.value" :label="item.label"
									:value="item.label">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="个人证件照">
							<el-upload class="avatar-uploader" :action="fileimg.uploadUrl" :show-file-list="false"
								:on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
								<img v-if="imageUrl" :src="imageUrl" class="avatar" />
								<i v-else class="el-icon-plus avatar-uploader-icon"></i>
							</el-upload>
							<div class="upload-but">
								<div>
									<p style="color: #FF0000;">照片上传注意事项</p></br>
									<p>上传电子版照片为近期免冠正面证件照，格式为jpg，大小为50K～100k，2寸照片。</p></br>
									<p>照片必须清晰反映本人特征，
										<span style="color: #FF0000;">如生活照、照片模糊或虚、红‘X’等情况，</span>
										均不能通过照片审核
									</p></br>
								</div>
							</div>
						</el-form-item>
					</div>
					<!-- <div class="titles">
						账号设置
					</div> -->
					<!-- <div style="width:1000px ;margin: 0 auto;margin-bottom: 59px;">
						<el-form-item label="账号">
							<el-input v-model="ruleForms.card" placeholder="请填写身份证号" :readonly='true'></el-input>
						</el-form-item>
						<el-row>
							<el-col :span="12">
								<el-form-item label="密码" prop="password">
									<el-input v-model="ruleForms.password" show-password placeholder="请填写密码(6-30个字符)">
									</el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="确认密码" prop="password_confirm">
									<el-input v-model="ruleForms.password_confirm" show-password placeholder="请填写确认密码">
									</el-input>
								</el-form-item>
							</el-col>
						</el-row>
					</div> -->
					<ul class="tips">
						<li>
							1、新密码为大小写字母和数字且至少为8位。
						</li>
						<li>
							2、新密码不应包含用户名。
						</li>
						<li>
							3、新密码不能是键盘排序。
						</li>
						<li>
							4、新密码不能包含特殊符号。
						</li>
					</ul>
					<el-form-item>
						<el-button type="primary" size="medium" :loading="rests" @click="submitForms('ruleForms')">注册
						</el-button>
						<el-button @click="resetForms('ruleForms')">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
		</el-dialog>
		<el-dialog title="提示" :visible.sync="oks" width="490px" top='35vh' :close-on-click-modal='false' class="ok">
			<div class="okimg"><img src="../../assets/index/ok.png" /></div>
			<div class="oktips">您的登录用户名为手机号或身份证号</div>
			<div class="okbut" @click="oks = false">立即登录</div>
		</el-dialog>
	</div>
</template>

<script>
import { encrypt } from '@/utils/crypto'; // 引入加密方法
	export default {
		data() {
			return {
				ruleForm: {
					account: '',
					password: '',
				},
				rules: {
					account: [{
						required: true,
						message: '请输入账号',
						trigger: 'blur'
					}],
					password: [{
						required: true,
						message: '请输入密码',
						trigger: 'blur'
					}],
				},
				//用户协议
				checked: true,
				dialogVisible: false,
				//忘记密码
				Refrules: {


				},
				dialogpwd: false,
				radio: 'email',
				// 发送验证码的 文本 以及按钮是否可以按
				FormRef: {
					email: '',
					mobile: '',
					newpassword: '',
					captcha: ''
				},
				type: "",
				btnText: "发送验证码",
				disabled: false,
				//配置项
				config: {
					full_login_bgimg: ''
				},
				group_id: '',
				//注册
				dialogrest: false,
				ruleForms: {
					username: '',
					password: '',
					password_confirm: '',
					nickname: '',
					mobile: '',
					email: '',
					card: '',
					company: '',
					learning_type: 0,
					picture: '',
					group_id: null
				},
				ruless: {
					password: [{
							required: true,
							message: '请输入密码',
							trigger: 'blur'
						},
						{
							min: 8,
							max: 20,
							message: '支持字母、数字、下划线组合，长度8-20位字符',
							trigger: 'blur'
						}
					],
					password_confirm: [{
							required: true,
							message: '请输入密码',
							trigger: 'blur'
						},
						{
							min: 8,
							max: 20,
							message: '支持字母、数字、下划线组合，长度8-20位字符',
							trigger: 'blur'
						}
					],
					company: [{
						required: true,
						message: '请输入单位名称',
						trigger: 'blur'
					}],
					nickname: [{
						required: true,
						message: '请输入真实姓名',
						trigger: 'blur'
					}],
					mobile: [{
						required: true,
						pattern: /^1\d{10}$/,
						message: '请输入正确的手机号',
						trigger: 'blur'
					}],
					email: [{
						required: true,
						pattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(.[a-zA-Z0-9_-]+)+$/,
						message: '请输入正确的邮箱',
						trigger: 'blur'
					}],
					card: [{
						required: true,
						pattern: /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
						message: '请输入正确的身份证号码',
						trigger: 'blur'
					}]
				},
				reveal: true,
				fileimg: {
					uploadUrl: this.$uploadApi,
				},
				imageUrl: '',
				//教育类别
				Learningdata: [],
				//单位名称
				Companydata: [],
				oks: false,
				rests: false
			}

		},
		created() {
			this.config = JSON.parse(sessionStorage.getItem('configs'))
			// this.group_id = this.$route.query.group_id
			this.ruleForms.group_id = parseInt(this.$route.query.group_id)
			console.log(this.$route.query)
			if (this.radio === 'email') {
				this.Refrules = {
					mobile: [],
					email: [{
						required: true,
						pattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(.[a-zA-Z0-9_-]+)+$/,
						message: '请输入正确的邮箱',
						trigger: 'blur'
					}],
					captcha: [{
						required: true,
						message: '请输入验证码',
						trigger: 'blur'
					}],
					newpassword: [{
						required: true,
						message: '请输入密码',
						trigger: 'blur'
					}],
				}
			} else {
				this.Refrules = {
					email: [],
					mobile: [{
						required: true,
						pattern: /^1\d{10}$/,
						message: '请输入正确的手机号',
						trigger: 'blur'
					}],
					captcha: [{
						required: true,
						message: '请输入验证码',
						trigger: 'blur'
					}],
					newpassword: [{
						required: true,
						message: '请输入密码',
						trigger: 'blur'
					}],

				}
			}
		},
		methods: {
			submitForm(formName) {
				if (this.checked) {
					this.$refs[formName].validate((valid) => {
						if (valid) {
              const encryptedName = encrypt(this.ruleForm.account);
              const encryptedPwd = encrypt(this.ruleForm.password);
							this.$http({
									method: 'POST',
									url: '/user/login1',
									headers: {
										requireAuth: false // 这里通过设置requireAuth为true来启用token检查
									},
									data: {
                    account: encryptedName,
                    password: encryptedPwd
                  },
								})
								.then(response => {
									if (response.code === 1) {
										let token = response.data.userinfo.token
										let userInfo = response.data.userinfo
										userInfo = JSON.stringify(userInfo)
										token = JSON.stringify(token)
										sessionStorage.setItem('userInfo', userInfo)
										sessionStorage.setItem('token', token)
										this.$message({
											message: response.msg,
											type: 'success'
										});

										this.$router.push({
											path: "/course",
										})
									} else {
										this.$message(response.msg);
									}

								})
								.catch(error => {
									console.log(error)
								})
						} else {
							console.log('error submit!!');
							return false;
						}
					});
				} else {
					this.$message({
						message: '请勾选用户协议',
						type: 'warning'
					});
				}

			},
			//注册
			register() {
				this.dialogrest = true
				this.getCompany()
				// this.$router.push({
				// 	path: "/register",
				// 	query: {
				// 		group_id: this.group_id,
				// 	}
				// })
			},
			//获取单位名称
			getCompany() {
				this.$http({
						method: 'POST',
						url: '/index/getCompany',
						headers: {
							requireAuth: false // 这里通过设置requireAuth为true来启用token检查
						},
					})
					.then(response => {
						if (response.code == 1) {
							this.Companydata = response.data
						} else {
							this.$message(response.msg);
						}

					})
					.catch(error => {
						console.log(error)
					})
			},
			//获取教育类别
			getLearningType() {
				this.$http({
						method: 'POST',
						url: '/index/getLearningType',
						headers: {
							requireAuth: false // 这里通过设置requireAuth为true来启用token检查
						},
					})
					.then(response => {
						if (response.code == 1) {
							this.Learningdata = response.data
						} else {
							this.$message(response.msg);
						}

					})
					.catch(error => {
						console.log(error)
					})
			},
			//上传证件照
			handleAvatarSuccess(res, file) {
				this.imageUrl = URL.createObjectURL(file.raw);
				this.ruleForms.picture = file.response.data.url
			},
			beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isLt2M = file.size / 1024 / 124 < 1;
				if (!isJPG) {
					this.$message.error('上传头像图片只能是 JPG 格式!');
					return isJPG && isLt2M;
				}
				if (!isLt2M) {
					this.$message.error('上传头像图片大小不能超过 100KB!');
					return isJPG && isLt2M;
				}
			},
			submitForms(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.ruleForms.username = this.ruleForms.card
						if (this.ruleForms.password == this.ruleForms.password_confirm) {
							this.rests = true
							this.$http({
									method: 'POST',
									url: '/user/register',
									headers: {
										requireAuth: false // 这里通过设置requireAuth为true来启用token检查
									},
									data: this.ruleForms
								})
								.then(response => {
									if (response.code == 1) {
										this.dialogrest = false
										this.rests = false
										// this.$message({
										// 	message: response.msg,
										// 	type: 'success'
										// });

										this.oks = true
										// this.$router.push({
										// 	path: "/index",
										// })
									} else {
										this.$message(response.msg);
										this.rests = false
									}

								})
								.catch(error => {
									console.log(error)
								})
						} else {
							this.$message.error('两次密码输入不一致');
						}
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			resetForms(formName) {
				this.$refs[formName].resetFields();
			},
			//打开用户协议
			handleOpen() {
				this.dialogVisible = true
			},
			//用户须知确定
			Noticeble() {
				this.checked = true
				this.dialogVisible = false
			},
			//修改密码
			forgotpwd() {
				this.dialogpwd = true
			},
			types() {
				this.$refs.FormRef.resetFields();
				if (this.radio === 'email') {
					this.Refrules = {
						mobile: [],
						email: [{
							required: true,
							pattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(.[a-zA-Z0-9_-]+)+$/,
							message: '请输入正确的邮箱',
							trigger: 'blur'
						}],
						captcha: [{
							required: true,
							message: '请输入验证码',
							trigger: 'blur'
						}],
						newpassword: [{
							required: true,
							message: '请输入密码',
							trigger: 'blur'
						}],
					}
				} else {
					this.Refrules = {
						email: [],
						mobile: [{
							required: true,
							pattern: /^1\d{10}$/,
							message: '请输入正确的手机号',
							trigger: 'blur'
						}],
						captcha: [{
							required: true,
							message: '请输入验证码',
							trigger: 'blur'
						}],
						newpassword: [{
							required: true,
							message: '请输入密码',
							trigger: 'blur'
						}],

					}
				}
			},
			//重置密码
			submitRef(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						const data = {
							type: this.radio,
							newpassword: this.FormRef.newpassword,
							captcha: this.FormRef.captcha
						};
						if (this.radio === 'mobile') {
							data.mobile = this.FormRef.mobile;
						} else {
							data.email = this.FormRef.email;
						}
						this.$http({
								method: 'POST',
								url: '/user/resetpwd',
								headers: {
									requireAuth: false
								},
								data: data
							})
							.then(response => {
								if (response.code == 1) {
									this.$message({
										message: response.msg,
										type: 'success'
									});
									this.$refs.FormRef.resetFields();
									this.dialogpwd = false

								} else {
									this.$message(response.msg);
								}
							})
							.catch(error => {
								console.log(error);
							});

					} else {
						return false;
					}
				});
			},
			resetRef(formName) {
				this.$refs[formName].resetFields();
			},
			// 发送验证码
			bindforgetSendCode() {
				//手机号 为空的话
				// this.$message("已发送验证码，请查收");
				// this.disabled = true;
				// this.btnText = "请稍候...";
				// setTimeout(() => {
				// 	this.doLoop(60);
				// }, 500);
				const field = this.radio === 'mobile' ? 'mobile' : 'email';
				const value = this.FormRef[field];
				this.$refs.FormRef.validateField(field, errorMessage => {
					if (!errorMessage) {
						this.$http({
								method: 'POST',
								url: this.radio === 'mobile' ? '/Sms/send' : '/Ems/send',
								headers: {
									requireAuth: false
								},
								data: {
									[field]: value,
									event: 'resetpwd'
								}
							})
							.then(response => {
								if (response.code == 1) {
									this.$message("已发送验证码，请查收");
									this.disabled = true;
									this.btnText = "请稍候...";
									setTimeout(() => {
										this.doLoop(60);
									}, 500);
								} else {
									this.$message(response.msg);
								}
							})
							.catch(error => {
								console.log(error)
							});
					} else {
						return false;
					}
				});

			}, // 手机验证码的倒计时
			doLoop: function(seconds) {
				seconds = seconds ? seconds : 60;
				this.btnText = seconds + "s后获取";
				// this.code = code
				let countdown = setInterval(() => {
					if (seconds > 0) {
						this.btnText = seconds + "s后获取";
						--seconds;
					} else {
						this.btnText = "获取验证码";
						this.disabled = false;
						clearInterval(countdown);
					}
				}, 1000);
			},

		}
	};
</script>
<style lang="scss" scoped>
	/deep/ .ok {
		.el-dialog__header {
			display: none;
		}

		.okimg {
			width: 135px;
			min-height: 130px;
			margin: 0 auto;

			img {
				width: 135px;
				height: auto;
			}
		}

		.oktips {
			width: 100%;
			height: 25px;
			font-family: SourceHanSansCN, SourceHanSansCN;
			font-weight: 400;
			font-size: 16px;
			color: rgba(0, 0, 0, 0.85);
			line-height: 24px;
			text-align: center;
		}

		.okbut {
			width: 170px;
			height: 40px;
			margin: 13px auto;
			text-align: center;
			background: #347CFE;
			border-radius: 20px;
			font-size: 18px;
			color: #FFFFFF;
			line-height: 40px;
			cursor: pointer;
		}
	}

	.bind_code {
		position: relative;

		.el-input__inner {
			width: 328px;
			height: 44px;
			background: #f7f7f7;
			border-radius: 4px;
			border: 1px solid #e4e4e4;
			outline: none;
			padding: 0 100px 0 10px;
		}

		.code /deep/.el-input__suffix {
			right: 97px;
		}

		.el-button {
			border: 0;
			background: none;
			padding: 0;
			border-radius: 0;
		}

		.pic {
			width: 80px;
			height: 25px;
			border-left: none !important;
		}

		.bind_code_gain {
			position: absolute;
			top: calc(50% - 9px);
			right: 10px;
			font-size: 14px;
			font-family: MicrosoftYaHei;
			color: #20aee5;
			line-height: 18px;
			cursor: pointer;
			padding-left: 10px;
			border-left: 1px solid #d8d8d8;
		}

		.login-icon {
			width: 16px;
			height: 16px;
			position: absolute;
			top: 14px;
			left: 16px;
		}
	}
</style>
<style>
	.tips {
		overflow: hidden;
		padding: 0 0 10px 50px;
	}

	.tips li {
		line-height: 20px;
		font-size: 14px;
		color: red;
		list-style-type: none;
	}

	.rests .el-dialog__header {
		padding: 10px 10px 10px 20px !important;
		font-weight: bold !important;
	}

	/* 我的*/
	.upload-but {
		width: 580px;
		line-height: 6px;
		float: left;
		text-align: left;
		margin-left: 15px;
	}

	.upload-but p {
		line-height: 30px;
		margin: 0 !important;
	}

	.upload-img {
		width: 120px;
		height: 158px;
		float: left;
		border: 1px solid #eee;
	}

	.upload-img img {
		width: 120px;
		height: 158px;

	}

	.avatar-uploader {
		width: 124px;
		float: left;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		border: 1px solid #d9d9d9;
		color: #8c939d;
		width: 125px;
		height: 165px;
		line-height: 175px !important;
		text-align: center;
	}

	.avatar {
		width: 125px;
		height: 165px;
		display: block;
	}

	/deep/.el-tabs__item {
		font-size: 16px !important;
	}

	.el-dialog {
		border-radius: 8px !important;
	}

	.el-dialog__header {
		border-bottom: 1px solid #eee;
	}

	li {
		list-style-type: none;
	}

	.check {
		width: 100%;
		height: 30px;
		margin: 0 auto;
	}

	.check div:nth-child(1) {
		float: left;
	}

	.check div:nth-child(1) a {
		font-size: 14px;
		color: rgba(0, 145, 255, 1);
	}

	.check div:nth-child(2) {
		line-height: 40px;
		float: right;
		color: rgba(0, 145, 255, 1);
		font-size: 14px;
		cursor: pointer;
	}

	.rest {
		color: rgba(0, 74, 193, 1);
		font-size: 14px;
		text-align: center;
		cursor: pointer;
	}

	.but {
		width: 100% !important;
		height: 45px !important;
		margin-left: 0 !important;
		background: #166BB2 !important;
		border-radius: 7px !important;
		border: 0 !important;
		color: #FFFFFF !important;
		font-size: 16px !important;
		margin-top: 0px !important;
	}

	#header {
		-moz-animation: header 1s 1.25s forwards;
		-webkit-animation: header 1s 1.25s forwards;
		-o-animation: header 1s 1.25s forwards;
		-ms-animation: header 1s 1.25s forwards;
		animation: header 1s 1.25s forwards;
		-moz-backface-visibility: hidden;
		-webkit-backface-visibility: hidden;
		-o-backface-visibility: hidden;
		-ms-backface-visibility: hidden;
		backface-visibility: hidden;
		-moz-transform: translate3d(0, 0, 0);
		-webkit-transform: translate3d(0, 0, 0);
		-o-transform: translate3d(0, 0, 0);
		-ms-transform: translate3d(0, 0, 0);
		transform: translate3d(0, 0, 0);
		cursor: default;
		display: inline-block;
		position: relative;
		text-align: center;
		top: 85px;
		vertical-align: middle;
		width: 100%;
	}

	#header h1 {
		font-size: 65px;
		font-weight: normal;
		letter-spacing: 7px;
		line-height: 65px;
	}

	#header p {
		font-size: 22px;
		margin: 0.75em 0 0.25em 0;
		opacity: 0.75;
		letter-spacing: 6px;
		color: #fff;
	}

	#header .content {
		margin: 1.5em 0 0 0;
	}

	#header .content {
		-moz-animation: nav-icons 0.5s ease-in-out forwards;
		-webkit-animation: nav-icons 0.5s ease-in-out forwards;
		-o-animation: nav-icons 0.5s ease-in-out forwards;
		-ms-animation: nav-icons 0.5s ease-in-out forwards;
		animation: nav-icons 0.5s ease-in-out forwards;
		-moz-backface-visibility: hidden;
		-webkit-backface-visibility: hidden;
		-o-backface-visibility: hidden;
		-ms-backface-visibility: hidden;
		backface-visibility: hidden;
		-moz-transform: translate3d(0, 0, 0);
		-webkit-transform: translate3d(0, 0, 0);
		-o-transform: translate3d(0, 0, 0);
		-ms-transform: translate3d(0, 0, 0);
		transform: translate3d(0, 0, 0);
		display: inline-block;
		/* height: 5.35em; */
		/* line-height: 5.885em; */

		position: relative;
		top: 0;
		width: 420px;
		height: 420px;
		/* background: #000; */
	}

	#header .content .left {
		float: left;
		width: 720px;
		height: 420px;
		background: rgba(255, 255, 255, 1);
		background-blend-mode: normal;
		box-shadow: 0px 0px 2px rgba(0, 71, 146, 0.44);
		border-radius: 8px;
		mix-blend-mode: normal;
	}

	#header .content .right {
		width: 420px;
		height: 380px;
		background: rgba(255, 255, 255, 1);
		background-blend-mode: normal;
		box-shadow: 0px 0px 2px rgba(0, 71, 146, 0.44);
		border-radius: 8px;
		mix-blend-mode: normal;
		/* float: right; */
		position: relative;
		margin: 0 auto;

	}

	.right .gotoMinPro {
		width: 60px;
		height: 60px;
		position: absolute;
		right: 0;
		top: 0;
		cursor: pointer;
	}

	.right .gotoMinPro .pFif {
		width: 60px;
		height: 60px;
		position: relative;
	}

	.right .gotoMinPro .pFif .imgBg {
		width: 60px;
		height: 60px;
		position: absolute;
		left: 0;
		top: 0;
	}

	.right .gotoMinPro .pFif .imgBg img {
		width: 60px;
		height: 60px;
		border-radius: 8px;
	}

	.right .gotoMinPro .pFif .title {
		color: #000;
		font-size: 14px;
		transform: rotate(45deg);
		-ms-transform: rotate(45deg);
		/* IE 9 */
		-moz-transform: rotate(45deg);
		/* Firefox */
		-webkit-transform: rotate(45deg);
		/* Safari 和 Chrome */
		-o-transform: rotate(45deg);
		/* Opera */
		position: absolute;
		z-index: 2;
		top: 20px;
		left: -10px;
	}

	.right .gotoMinPro .quickMark {
		width: 200px;
		height: 200px;
		position: absolute;
		top: 0;
		left: 80px;
		opacity: 0;
		display: none;
	}

	.right .gotoMinPro:hover .quickMark {
		opacity: 1;
		display: block;
	}

	.right .gotoMinPro .quickMark img {
		width: 200px;
		height: 200px;
		border-radius: 10px;
	}

	.topic {
		width: 100%;
		height: 60px;
		border-bottom: 1px solid rgba(151, 151, 151, 1);
	}

	.topic .name {
		float: left;
		height: 60px;
		line-height: 60px;
		mix-blend-mode: normal;
		color: rgba(20, 21, 21, 1);
		letter-spacing: 1.8px;
		font-size: 22px;
		line-height: 60px;
		padding-left: 20px;
	}

	.topic .more {
		float: right;
		width: 60px;
		height: 25px;
		background: rgba(0, 119, 255, 0.5);
		background-blend-mode: normal;
		border-radius: 12px;
		mix-blend-mode: normal;
		color: #fff;
		text-align: center;
		line-height: 25px;
		margin-top: 17px;
		margin-right: 20px;
		font-size: 12px;
	}

	nav {
		width: 1200px;
		height: 80px;
		margin: 0 auto;
		margin-top: 20px;
	}

	nav ul li {
		float: left;
	}

	nav .first {
		width: 80px;
		height: 80px;
		margin-right: 20px;
	}

	nav .first img {
		width: 80px;
		height: 80px;
	}

	nav .itemLink {
		width: 133px;
		height: 50px;
		border: 1px solid rgba(255, 255, 255, 1);
		mix-blend-mode: normal;
		border-radius: 5px;
		margin-top: 15px;
	}

	nav .itemLink .icon {
		width: 35px;
		height: 35px;
		margin: 6.5px;
		float: left;
	}

	nav .itemLink .icon img {
		width: 35px;
		height: 35px;
	}

	nav .itemLink .topicIn {
		line-height: 48px;
		font-size: 16px;
		color: #fff
	}

	nav .itemTo {
		width: 65px;
		height: 51px;
		margin: 20px;
	}

	nav .itemTo img {
		width: 60px;
		height: 15px;
	}

	#header nav li:nth-child(1) {
		-moz-animation-delay: 2.5s;
		-webkit-animation-delay: 2.5s;
		-o-animation-delay: 2.5s;
		-ms-animation-delay: 2.5s;
		animation-delay: 2.5s;
	}

	#header nav li:nth-child(2) {
		-moz-animation-delay: 2.75s;
		-webkit-animation-delay: 2.75s;
		-o-animation-delay: 2.75s;
		-ms-animation-delay: 2.75s;
		animation-delay: 2.75s;
	}

	#header nav li:nth-child(3) {
		-moz-animation-delay: 3s;
		-webkit-animation-delay: 3s;
		-o-animation-delay: 3s;
		-ms-animation-delay: 3s;
		animation-delay: 3s;
	}

	#header nav li:nth-child(4) {
		-moz-animation-delay: 3.25s;
		-webkit-animation-delay: 3.25s;
		-o-animation-delay: 3.25s;
		-ms-animation-delay: 3.25s;
		animation-delay: 3.25s;
	}

	#header nav li:nth-child(5) {
		-moz-animation-delay: 3.5s;
		-webkit-animation-delay: 3.5s;
		-o-animation-delay: 3.5s;
		-ms-animation-delay: 3.5s;
		animation-delay: 3.5s;
	}

	#header nav li:nth-child(6) {
		-moz-animation-delay: 3.75s;
		-webkit-animation-delay: 3.75s;
		-o-animation-delay: 3.75s;
		-ms-animation-delay: 3.75s;
		animation-delay: 3.75s;
	}

	#header nav li:nth-child(7) {
		-moz-animation-delay: 4s;
		-webkit-animation-delay: 4s;
		-o-animation-delay: 4s;
		-ms-animation-delay: 4s;
		animation-delay: 4s;
	}

	#header nav li:nth-child(8) {
		-moz-animation-delay: 4.25s;
		-webkit-animation-delay: 4.25s;
		-o-animation-delay: 4.25s;
		-ms-animation-delay: 4.25s;
		animation-delay: 4.25s;
	}

	#header nav li:nth-child(9) {
		-moz-animation-delay: 4.5s;
		-webkit-animation-delay: 4.5s;
		-o-animation-delay: 4.5s;
		-ms-animation-delay: 4.5s;
		animation-delay: 4.5s;
	}

	#header nav li:nth-child(10) {
		-moz-animation-delay: 4.75s;
		-webkit-animation-delay: 4.75s;
		-o-animation-delay: 4.75s;
		-ms-animation-delay: 4.75s;
		animation-delay: 4.75s;
	}
</style>